
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"none","d":"M0 0h32v32H0z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M18.94 14.92a3.3 3.3 0 01.36 1.34v.13a.93.93 0 010-.13 3.39 3.39 0 01.41-1.34 2.51 2.51 0 012.36-1.3 2.75 2.75 0 01-2.77-2.77A2.48 2.48 0 0118 13.2a3.57 3.57 0 01-1.47.42A3 3 0 0118 14a2.36 2.36 0 01.94.92zm-3.31-5.54v3.47l.41-.21a6.57 6.57 0 001.4-1v-2a10.8 10.8 0 00-1.81-.26zm11.62-1.83V5.44h-1.82a8 8 0 001.82 2.11zm-3.82 7.72h-1.88a6.38 6.38 0 00-1.25 1.6l-.11.21h3.63a9.9 9.9 0 00-.39-1.81z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M25.45 13.27v.39h.67-.68v1.56h-.93a11.73 11.73 0 00-.46 1.81h1.39v8h-8v-8h1l-.1-.21A5.75 5.75 0 0016 14.51l-.41-.19v.95h-8v-8h8v2a12 12 0 001.81-.39V7.24h1.82v-.42.42h1.47a7.79 7.79 0 001.72-1.8H5.82v21.45h21.43v-15.7a8 8 0 00-1.8 2.08zm-9.82 11.8h-8v-8h8z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M19.54 9.39a4.07 4.07 0 014.29 4.27 5.31 5.31 0 01.7-2.4 3.67 3.67 0 012.41-1.74 5.17 5.17 0 011.17-.13 5.08 5.08 0 01-1.16-.13 4.08 4.08 0 01-3.05-3.51 6.33 6.33 0 01-.07-.64v.64a3.73 3.73 0 01-1.41 2.61 5.38 5.38 0 01-2.88 1.03z"}})])
          )
        }
      }
    